import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/products/lead-gen')({
  component: Outlet,
});
